<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop>
    <template v-slot>
      <div class="dialog type-xlarge">
        <header class="dialog-header">
          <h2 class="dialog-title">배송지 설정</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <div class="c-round-box">
              <strong class="subject">선택한 배송지</strong>
              <div class="text-wrap" v-if="selectedAddress">
                <p class="text">
                  <b class="color-primary">
                    [{{ selectedAddress.dlvdesNm || "-" }}]
                  </b>
                  {{ selectedAddress.acptrNm }} ({{ selectedAddress.zip }})
                </p>
                <p class="text">
                  {{ selectedAddress.roadNmBscAddr }}
                  {{ selectedAddress.roadNmDtlAddr }} (연락처 :
                  {{ selectedAddress.acptrWrdTelno }} /
                  {{ selectedAddress.acptrMblTelno }})
                </p>
              </div>
            </div>
            <div class="c-btn-area flex-ar mt24">
              <button
                type="button"
                class="c-util-button type-line-black type-small"
                @click="showEditPopForAdd"
              >
                <span>배송지 추가</span>
              </button>
            </div>

            <div class="scroll-x">
              <div class="scroll-x-inner">
                <div class="c-table type-no-top-line" style="width: 930px">
                  <table>
                    <caption>
                      개인정보에 관한 민원서비스 테이블
                    </caption>
                    <colgroup>
                      <col style="width: 60px" />
                      <col style="width: 14.957%" />
                      <col style="width: 10.683%" />
                      <col />
                      <col style="width: 14.957%" />
                      <col style="width: 14.957%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="ac">선택</th>
                        <th class="ac">주소지 별칭</th>
                        <th class="ac">받는분</th>
                        <th class="ac">배송 주소</th>
                        <th class="ac">연락처</th>
                        <th class="ac">수정/삭제</th>
                      </tr>
                    </thead>
                    <tbody>
                      <AddressRow
                        v-for="item in addresses"
                        :key="item.dlvdesSn"
                        :address="item"
                        @select="onAddressSelected"
                        @edit="(address) => showEditPopForEdit(address)"
                        @delete="(address) => deleteAddress(address)"
                      />
                    </tbody>
                  </table>
                </div>
                <div class="dialog-footer dialog-footer-delivery">
                  <div class="c-btn-area">
                    <button
                      type="button"
                      class="c-button type-secondary"
                      @click="() => emits('close')"
                    >
                      <span>취소</span>
                    </button>
                    <button
                      type="button"
                      class="c-button type-primary"
                      @click="emitSelect"
                    >
                      <span>배송지 선택</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>

  <AddressEditPop
    v-if="isShowEditPop"
    v-bind="editPopProps"
    @close="() => (isShowEditPop = false)"
    @updated="loadAddresses"
  />
</template>
<script setup>
import {
  inject,
  onMounted,
  ref,
  defineEmits,
  computed,
  defineProps,
} from "vue";
import { api } from "@/plugins/api";
import AddressRow from "@/components/paintpro/agency/agencyDeliveryAddressRow.vue";
import AddressEditPop from "@/components/paintpro/agency/agencyDeliveryAddressEditPop.vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import * as cmUtil from "@/utils/cmUtil";

const url = inject("url_prefix");

const emits = defineEmits(["close", "select"]);

const props = defineProps({
  dlvdesSn: {
    type: Number,
    default: null,
  },
});

const addresses = ref([]);

const isShowEditPop = ref(false);
const editPopProps = ref({
  address: null,
});

onMounted(() => {
  loadAddresses();
});

const selectedAddress = computed(() => {
  return addresses.value.find((item) => item.selected);
});

const showEditPopForAdd = () => {
  editPopProps.value.address = null;
  isShowEditPop.value = true;
};

const showEditPopForEdit = (address) => {
  editPopProps.value.address = address;
  isShowEditPop.value = true;
};

const deleteAddress = async (address) => {
  if (
    !(await cmUtil.confirm(`${address.dlvdesNm} 배송지를 삭제하시겠습니까?`))
  ) {
    return;
  }

  const res = await api.post(
    `${url}/agency/delivery/address/${address.dlvdesSn}/delete`
  );

  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  await cmUtil.alert("배송지가 삭제되었습니다.");
  loadAddresses();
};

const loadAddresses = async () => {
  const res = await api.get(`${url}/agency/delivery/address/addresses`);

  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return;
  }

  addresses.value = res.data.map((item) => {
    return {
      ...item,
      selected: props.dlvdesSn === item.dlvdesSn ? true : false,
    };
  });
};

const onAddressSelected = (dlvdesSn) => {
  addresses.value.forEach((item) => {
    item.selected = item.dlvdesSn === dlvdesSn;
  });
};

const emitSelect = async () => {
  if (!selectedAddress.value) {
    await cmUtil.alert("배송지를 선택하세요.");
    return;
  }

  emits("select", selectedAddress.value);
  emits("close");
};
</script>
